/**
 * ============================================================================
 *   Copyright (c) 2026 Dobler Data Solutions, LLC. ALL RIGHTS RESERVED.
 * ============================================================================
 *   Module       : FilterBar
 *   Feature      : 197-portal-light-theme-responsive (design blueprint)
 *   Description  : Canonical filter/toolbar row above a table — a Card holding a
 *                  responsive flex row of search + filter controls (kit Input /
 *                  Select / Button). Replaces the per-page ad-hoc filter panels.
 *   Blueprint    : docs/design-blueprint.md
 *   Constitution : v1.19.0
 *   Author       : Peter Dobler
 * ============================================================================
 */
import React from 'react';
import { clsx } from 'clsx';
import { Card } from './base';

export interface FilterBarProps {
  children: React.ReactNode;
  /** Right-aligned content (e.g. a result count or an action). */
  trailing?: React.ReactNode;
  className?: string;
}

/** Canonical filter/toolbar row. Put kit Input/Select/Button controls inside. */
export const FilterBar: React.FC<FilterBarProps> = ({ children, trailing, className }) => (
  <Card className={clsx('mb-[var(--space-section)]', className)}>
    <div className="flex flex-wrap items-end gap-3">
      {children}
      {trailing && <div className="ml-auto flex items-center gap-3">{trailing}</div>}
    </div>
  </Card>
);

export default FilterBar;
